import './styles/App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ReactGA from 'react-ga4';

import PageConverter from './components/PageConverter';
import Header from './components/Header';
import Footer from './components/Footer';
import PagePrivacyPolicy from './components/PagePrivacyPolicy';

// Initialize Google Analytics only in production
if (process.env.REACT_APP_ENV === 'PROD') {
  const TRACKING_ID = 'G-465QY68V24';
  ReactGA.initialize(TRACKING_ID);
}

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<PageConverter />} />
        <Route path="/privacy-policy" element={<PagePrivacyPolicy />} />
      </Routes>
      <Footer />

    </BrowserRouter>
  );
}

export default App;
